import React from 'react';
import { jobs } from '../data/jobs';
import '../styles/Experience.css';

const Experience: React.FC = () => {
    return (
        <section className="experience section" id="experience">
            <div className="experience-content">
                <h1>experience</h1>
                <div className="experience-list">
                    {jobs.map((job, index) => (
                        <div key={index} className="experience-item">
                            <h2>{job.title} at {job.company}</h2>
                            <p>{job.startDate} - {job.endDate}</p>
                            <ul>
                                {job.description.split('\n').map((sentence, idx) => (
                                    <li key={idx}>{sentence}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Experience;
